import { FC, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import cn from 'classnames';
import { ValuesType } from 'utility-types';
import { UseSelectStateChange } from 'downshift';
import { Button } from '@ebsco-ui/ebsco-ui';

import { Dropdown } from '@app/components';
import { useAppContext } from '@app/contexts';
import { sharedMessages } from '@app/translations';
import { PropsWithClassName, supportedLocales } from '@app/constants';

import css from './LocaleDropdown.module.scss';

export const LocaleDropdown: FC<PropsWithClassName> = ({ className = '' }) => {
  const { $t } = useIntl();
  const { locale, setSelectedLocale } = useAppContext();
  const [selectedDropdownLocale, setSelectedDropdownLocale] = useState(locale);

  const handleSelectedLocaleChange = ({
    selectedItem,
  }: UseSelectStateChange<ValuesType<typeof supportedLocales>>) => {
    if (selectedItem?.id) {
      setSelectedDropdownLocale(selectedItem.id);
    }
  };

  return (
    <>
      <Dropdown
        className={cn(css.localeDropdown, className)}
        label={$t({
          id: 'selectYourLanguage',
          defaultMessage: 'Select your language',
        })}
        items={supportedLocales}
        selectedItem={supportedLocales.find(
          ({ id }) => id === selectedDropdownLocale
        )}
        styleType="standard"
        onSelectedItemChange={handleSelectedLocaleChange}
      />
      <Button
        className={css.saveButton}
        styleType="default"
        onClick={() => setSelectedLocale(selectedDropdownLocale)}
      >
        <FormattedMessage {...sharedMessages.save} />
      </Button>
    </>
  );
};
